const dictionary = {
  size: "small",
  btnVaraint: "contained",
  txtVar: "h6",
  type: "submit",
  passwordInput: "password",
  recoverType: "caption",
};
export default dictionary;
